import { useLocation } from "react-router-dom";
import { bearerToken, loadTokens } from "@common/auth/session";
import BugReportForm, { DiagnosticLogs } from "@jkast90/kast-common/bug-report-form";
import type { AdminMode } from "../hooks/useAdminMode";
import type { Session } from "../hooks/useSession";

const FORM_CLASSES = { button: "btn", primaryButton: "btn primary", hint: "muted small" };
const LOG_CLASSES = { button: "btn small", primaryButton: "btn small primary" };

const getToken = () => bearerToken(loadTokens());

/**
 * /bug-report: reports go to the kast-dev admin inbox, not salvagers-api.
 * Pre-filled with the crash when arriving from the crash screen.
 */
export default function BugReportPage({ session, adminMode }: { session: Session; adminMode: AdminMode }) {
  const { user, signIn } = session;
  const crashNote = (useLocation().state as { crashNote?: string } | null)?.crashNote ?? "";
  return (
    <main className="page">
      <h1>Report a bug</h1>
      <BugReportForm
        app="salvagersgame"
        user={user ? { id: user.sub, email: user.email } : null}
        getToken={getToken}
        onSignIn={signIn}
        initialDescription={crashNote}
        classNames={FORM_CLASSES}
      />
      {adminMode.on && (
        <section>
          <h2>Attached logs</h2>
          <DiagnosticLogs classNames={LOG_CLASSES} />
        </section>
      )}
    </main>
  );
}
